import { Fragment, useEffect } from 'react'
import { NextSeo } from 'next-seo'

import withPage from '@/lib/page/withPage'

import withServiceLayout from '@/features/Services/layouts/withServiceLayout'
import ServiceSection from '@/features/Services/templates/ServiceSection'
import PriceSection from '@/features/Services/templates/PriceSection'

import { WhatYouGet } from '@/components/Landing'

import { PRIVACY } from '@/features/Services/constants'
import { logEcommerce } from '@/lib/stats/gtm'

function Privacy() {
  useEffect(() => {
    logEcommerce('view_item', {
      items: [
        {
          item_id: 'Privacy Policy',
          item_name: 'Privacy Policy',
          quantity: 1,
        },
      ],
    })
  }, [])
  return (
    <Fragment>
      <NextSeo title="Privacy Policy" />

      <ServiceSection data={PRIVACY} />
      <PriceSection serviceName="PRIVACY" />
      <WhatYouGet hideDecor primaryColor={PRIVACY.PRIMARY_COLOR} />
    </Fragment>
  )
}

export default withPage()(withServiceLayout(Privacy))
